import { render, staticRenderFns } from "./chatMsgList.vue?vue&type=template&id=0f686860"
import script from "./chatMsgList.vue?vue&type=script&lang=js"
export * from "./chatMsgList.vue?vue&type=script&lang=js"
import style0 from "./chatMsgList.vue?vue&type=style&index=0&id=0f686860&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports